import {
    GET_RAVEN_AUTHORIZATION_RESPONSE_CODE_DEF_SUCCESS,
    RAVEN_AUTHORIZATION_RESPONSE_CODE_DEF_API_ERROR
} from "./actionTypes"

const INIT_STATE = {
    recordList: [], //Model Data ve Error
    error: {},
}

const ravenAuthorizationResponseCodeDef = (state = INIT_STATE, action) => {
    switch (action.type) {

        case GET_RAVEN_AUTHORIZATION_RESPONSE_CODE_DEF_SUCCESS:
            return {
                ...state,
                recordList: action.payload,
            }

        case RAVEN_AUTHORIZATION_RESPONSE_CODE_DEF_API_ERROR:
            return {
                ...state,
                error: action.payload,
            }

        default:
            return state
    }
}

export default ravenAuthorizationResponseCodeDef